/* eslint-disable max-lines-per-function */
import { api } from "jiffy-api";
import { track } from "jiffy-analytics";
import EventClass from "common/utils/ui/event-class";
import { writeCookie } from "common/utils/cookie";
import "./digital-assets-dtf-modal-items.scss";

class DigitalAssetsDtfModalItems extends EventClass {
  #stopRedirectCategory = {};

  #itemsSectionsSelector = "";

  #loaderSelector = "";

  #titleSelector = "";

  constructor(props) {
    super(props);

    this.#itemsSectionsSelector = props.itemsSectionsSelector;
    this.#loaderSelector = props.loaderSelector;
    this.#titleSelector = props.titleSelector;
  }

  get #itemsSections() {
    return document.querySelectorAll(this.#itemsSectionsSelector);
  }

  get #progressText() {
    return document.querySelector(this.#titleSelector);
  }

  get #loader() {
    return document.querySelector(this.#loaderSelector);
  }

  #showSections() {
    this.#itemsSections.forEach($section => $section.classList.remove("hidden"));
  }

  #hideSections() {
    this.#itemsSections.forEach($section => $section.classList.add("hidden"));
  }

  #showLoader() {
    this.#loader.classList.remove("hidden");
  }

  #hideLoader() {
    this.#loader.classList.add("hidden");
  }

  #prepareLoader($item, category) {
    this.#showLoader();
    this.#hideSections();
    this.#progressText.textContent = `Preparing the design for Jiffy ${category}...`;
  }

  async event(event, $item) {
    event.preventDefault();

    const { catalogNumber, category } = $item.dataset;
    const { pathname } = new URL(window.location.href);
    const slug = pathname.split("/").pop().split(".html")[0];

    this.#stopRedirectCategory[catalogNumber] = false;
    this.#prepareLoader($item, category);
    const fileIds = await api.digitalAssets.getUploadFileIds({ slug });
    track("digital_asset_files_prepared", { slug, file_ids: fileIds });
    const fileCount = fileIds.length;
    const fileText = fileCount > 1 ? "files" : "file";
    let uploadedFileCount = 0;
    this.#progressText.textContent = `Processing ${
      uploadedFileCount + 1
    } out of ${fileCount} ${fileText}`;

    const uploadPromises = fileIds.map(id => {
      const formData = new FormData();
      formData.append("catalog_number", catalogNumber);
      formData.append("digital_assets_file_id", id);
      track("digital_asset_image_upload_started", { digital_assets_file_id: id });
      return api.dtf
        .uploadArtwork(formData, {
          raw: true,
          headers: { "Content-Type": undefined },
          useAxiosForRequest: true
        })
        .then(response => {
          uploadedFileCount += 1;
          if (uploadedFileCount < fileCount) {
            this.#progressText.textContent = `Processing ${
              uploadedFileCount + 1
            } out of ${fileCount} ${fileText}...`;
          }
          track("digital_asset_image_upload_completed", { digital_assets_file_id: id });
          return response;
        });
    });

    Promise.all(uploadPromises)
      .then(results => {
        if (this.#stopRedirectCategory[catalogNumber]) return;
        this.#progressText.textContent = `Redirecting to Jiffy ${category}...`;
        const artworkIds = [];
        const artworkUrls = {};
        let url = new URLSearchParams($item.getAttribute("href"));

        results.forEach(artwork => {
          artworkIds.push(artwork.id);
          artworkUrls[artwork.id] = artwork.url;
        });

        writeCookie("uploaded_artwork_ids", JSON.stringify(artworkIds), 300);
        url.append("artwork_urls", encodeURIComponent(JSON.stringify(artworkUrls)));
        url = decodeURIComponent(url.toString());
        window.location.href = url;
      })
      .catch(error => {
        // eslint-disable-next-line no-alert
        alert("Something went wrong, please try again");
        track("digital_asset_image_upload_error", { error });
        window.Honeybadger?.notify("Digital Assets: Image upload error", { params: { error } });
      });
  }

  stopLoading() {
    Object.keys(this.#stopRedirectCategory).forEach(key => {
      this.#stopRedirectCategory[key] = true;
    });
    this.#hideLoader();
    this.#showSections();
  }
}

export default () =>
  new DigitalAssetsDtfModalItems({
    eventSelector: ".js-digital-assets-dtf-modal-items__preview",

    itemsSectionsSelector: ".js-digital-assets-dtf-modal-section",
    loaderSelector: ".js-digital-assets-dtf-modal__loader",
    titleSelector: ".js-digital-assets-dtf-modal__title"
  });
